






















import Vue from 'vue';

import store from '@/store';

import {
  BasePacketKind,
  BasePacket,
  Badge,
  Objective,
  Outcome
} from '@/models/packet';

import MultiPointPacketEditor from '@/components/MultiPointPacketEditor.vue';
import SinglePointPacketEditor from '@/components/SinglePointPacketEditor.vue';
import { WebRequestStatus } from '@/models';

export default Vue.extend({
  components: {
    SinglePointPacketEditor,
    MultiPointPacketEditor
  },

  props: {
    packetId: Number
  },

  computed: {
    publicPacket(): [BasePacket, Badge[]] {
      return store.getters.org.publicPacket(this.packetId);
    },

    packet(): BasePacket {
      const [packet] = this.publicPacket;

      console.log({ packet });

      return packet;
    },

    badges(): [Badge, WebRequestStatus][] {
      const [, badges] = this.publicPacket;

      console.log({ badges });

      return badges.map(b => [b, WebRequestStatus.READY]);
    },

    statusedObjectives(): [Objective, WebRequestStatus.READY][] {
      return (this.packet?.objectives || []).map(o => [
        o,
        WebRequestStatus.READY
      ]);
    },

    statusedOutcomes(): [Outcome, WebRequestStatus.READY][] {
      return (this.packet?.outcomes || []).map(o => [
        o,
        WebRequestStatus.READY
      ]);
    },

    isSinglePoint(): boolean {
      return this.packet.kind === BasePacketKind.SINGLE_POINT;
    }
  }
});
